module.exports = __webpack_public_path__ + "img/sc-3p-blank.65751746.png";